(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/models/grassroots.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/models/grassroots.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.models.Grassroots = Backbone.Model.extend({
    defaults: {
      offsetPoints: 5,
      offsetSupporters: 5
    }
  });
})(Backbone, _, svs);


 })(window);